import { InteractionType } from "@edgetier/watchtower-types";

export interface ISidebarItemWrapperProps {
    children: React.ReactNode;
    onClick?: () => void;
    active?: boolean;
    "data-testid"?: string;
}

export interface ISidebarItemProps {
    interactionType: InteractionType;
    dateTime: Date;
    onClick?: () => void;
    active?: boolean;
}
export interface ISidebarFetchMoreItemsProps {
    onClick?: () => void;
    label: string;
    type: SidebarItemType;
    isLoading?: boolean;
}

export enum SidebarItemType {
    Older = "older",
    Newer = "newer",
}
